
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Layer_1","data-name":"Layer 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('path',{attrs:{"d":"M458.004 815.44a24.064 24.064 0 01-5.115-47.572l149.13-32.601a24.06 24.06 0 0110.276 47.011l-149.13 32.601a24.185 24.185 0 01-5.161.56z","fill":"#f8cc61"}}),_c('path',{attrs:{"d":"M495.286 807.29a24.067 24.067 0 01-23.48-18.927L427.577 586.04a24.06 24.06 0 1147.01-10.279l44.226 202.322a24.081 24.081 0 01-23.528 29.205zM569.85 790.988a24.067 24.067 0 01-23.48-18.926L502.143 569.74a24.06 24.06 0 1147.009-10.278l44.227 202.322a24.081 24.081 0 01-23.528 29.204z","fill":"#f8cc61"}}),_c('rect',{attrs:{"x":"674.453","y":"352.231","width":"134.571","height":"93.305","rx":"46.652","fill":"#f8cc61"}}),_c('path',{attrs:{"d":"M735.506 403.59C732.987 578 590.8 718.61 415.792 718.61a318.615 318.615 0 01-218.182-86.004c-14.148-13.212-4.08-36.685 15.272-36.175q2.646.07 5.31.07c108.385 0 196.368-87.251 197.58-195.348.02-.75.02-1.52.02-2.271s0-1.521-.02-2.272A159.859 159.859 0 01574.21 238.994c90.206-.784 162.598 74.396 161.296 164.596z","fill":"#f7f4e5"}}),_c('path',{attrs:{"d":"M544.295 562.29c-10.402 68.312-76.365 113.491-144.416 101.503-191.332-33.706-202.342-195.842-199.51-256.891a20.95 20.95 0 0124.37-19.639l218.74 36.178a122.133 122.133 0 01100.816 138.85z","fill":"#f7f4e5"}}),_c('circle',{attrs:{"cx":"589.993","cy":"398.884","r":"61.078","fill":"#4d3d36"}})])
          )
        }
      }
    